import type { PayloadAction } from '@reduxjs/toolkit';
import { createSlice } from '@reduxjs/toolkit';

import type { ActivityEventDetails } from '@shared/services/activities_events/types/activitiesEvents.types';
import type { GetActivitiesEventsFiltersResponse } from '@shared/services/activities_events/types/activitiesEventsFilters.type';

import { initialState } from './initialState';
import type { FilterOptionType } from '../types';

const activitiesEventsSlice = createSlice({
  initialState,
  name: 'ActivitiesEvents',
  reducers: {
    setSelectedFilter: (
      state,
      action: PayloadAction<{
        filterType: FilterOptionType;
        options: number | string | string[] | undefined;
      }>
    ) => {
      const { filterType, options } = action.payload;
      state.selectedFilters[filterType] = options as never;
    },
    clearFilterValue: (state, action: PayloadAction<FilterOptionType>) => {
      const filterType = action.payload;
      state.selectedFilters[filterType] = initialState.selectedFilters[filterType] as never;
    },
    clearSelectedFilter: (state) => {
      state.selectedFilters = initialState.selectedFilters;
    },
    setFilterOptions: (state, action: PayloadAction<GetActivitiesEventsFiltersResponse>) => {
      state.filterOptions = action.payload;
    },
    setBookingError: (state, action: PayloadAction<string | undefined>) => {
      state.bookingError = action.payload;
    },
    clearBookingError: (state) => {
      state.bookingError = undefined;
    },
    setBookedActivityEvent: (state, action: PayloadAction<ActivityEventDetails>) => {
      state.bookedActivityEvent = action.payload;
    },
    clearBookedActivityEvent: (state) => {
      state.bookedActivityEvent = initialState.bookedActivityEvent;
    },
  },
});

export const { actions: activitiesEventsAction } = activitiesEventsSlice;

export default activitiesEventsSlice.reducer;
